import React, { useEffect, useState } from "react";
import api from "../api";

function Card({ children, className = "" }) {
  return <div className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm ${className}`}>{children}</div>;
}

export default function ClientContractors() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/client/contractors").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-4" data-testid="client-contractors">
      <Card>
        <h2 className="text-base font-bold text-slate-900">My Contractors</h2>
        <p className="text-sm text-slate-500">Contractors assigned to your programs and their training status. (Pay rates are managed by Campbell and not shown here.)</p>
      </Card>
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="text-xs uppercase tracking-wide text-slate-400">
              <tr><th className="py-2 pr-4">Contractor</th><th className="py-2 pr-4">Program</th><th className="py-2 pr-4">Stage</th><th className="py-2 pr-4">Training scheduled</th><th className="py-2 pr-4">Production ready</th></tr>
            </thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={5} className="py-8 text-center text-slate-400">No contractors assigned to your programs yet.</td></tr>}
              {rows.map((c) => (
                <tr key={c.contractor_id} className="border-b border-slate-50" data-testid={`client-contractor-${c.contractor_id}`}>
                  <td className="py-3 pr-4 font-medium text-slate-800">{c.name}</td>
                  <td className="py-3 pr-4 text-slate-600">{c.program}</td>
                  <td className="py-3 pr-4"><span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600">{c.stage}</span></td>
                  <td className="py-3 pr-4 text-slate-600">{c.training_scheduled_date || "—"}</td>
                  <td className="py-3 pr-4">{c.production_ready ? <span className="text-emerald-600 font-semibold">Yes</span> : <span className="text-slate-400">No</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
